import styled from "styled-components";
import { css } from 'styled-components';

const breakpoints = {
  M: 648,
  L: 1026,
  XL: 1200,
};

export const devices = {
  S: `(max-width: ${breakpoints.M - 1}px)`,
  M: `(min-width: ${breakpoints.M}px)`,
  L: `(min-width: ${breakpoints.L}px)`,
  XL: `(min-width: ${breakpoints.XL}px)`,
};

export const AppWrapper = styled.main`
  font-family: ${({ theme }) => theme.bodyFont};
  color: ${({ theme }) => theme.dark};
  line-height: 1.3;
  //padding: 15px 0;
  min-height: calc(100vh - 60px);
  /* background-color: rgba(83, 104, 145, 0.6); */
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgb(239, 239, 239);
  position:relative;
  max-width:1978px;
  margin:auto;
  //overflow: hidden;

  font-size: 14px;

  // margin at the top of the app to account for ICONs header size changing (and hiding the progress bar)
  @media (min-width: 766px) {
    margin-top: 66px;
  }
  @media (min-width: 767px) {
    margin-top: 67px;
  }
  @media (min-width: 1200px) {
    margin-top: 136px;
  }

  @media ${devices.M} {
    //padding: 15px 20px;
    padding-bottom: 0px;
  }

  * {
    font-family: inherit;
  }

  *:focus {
    outline: 2px solid transparent;
  }

  h1 {
    color: ${({ theme }) => theme.primary};
    display: inline-block;
    font-size: 22px;
    font-weight: 800;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: center;
    text-transform: uppercase;

    @media ${devices.M} {
      font-size: 26px;
      line-height: 30px;
    }

    @media ${devices.L} {
      //max-width: 442px;
    }
  }

  h2 {
    color: ${({ theme }) => theme.primary};
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    max-width: 355px;
    margin-bottom: 24px;
  }

  p {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 30px;
    color: ${({ theme }) => theme.body};
    margin-bottom: 16px;
    display: block;
  }

  sup {
    font-size: 0.7em;
    position: relative;
    top: -0.4em;
    vertical-align: top;
  }

  sub {
    vertical-align: bottom;
    font-size: 0.6em;
  }

  small {
    font-size: 12px;
    line-height:18px;
    font-weight:400;
  }

  em {
    font-style: italic;
  }
  
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1165px;
  margin: 0 auto;

  @media ${devices.L} {
    max-width: 1165px;
    position: unset;
  }
`;

export const ContentWrapper = styled.div`
  border-radius: 14px;
  box-shadow: 0 4px 8px 2px rgba(60, 64, 67, 0.15),
    0 1px 3px 0 rgba(60, 64, 67, 0.3);
  padding: 30px 15px;
  background-color: rgba(255, 255, 255);
  background-image: url("card-bg.gif");
  background-position: bottom center;
  background-repeat: repeat-x;
  margin-top: 230px;
  overflow-x: hidden;
  padding: 32px 16px 62px;


  @media ${devices.M} {
    margin-top: 344px;
    height: auto;
    overflow-y: hidden !important;
    //max-width: 541px;
    padding: 32px 42px 62px;
  }
  @media ${devices.L} {
    margin-top: 130px;
    max-width: 652px;
    padding: 32px 32px 62px;
  }
`;

export const ButtonOld = styled.button`
  font-family: "Montserrat";
  min-width: 197px;
  min-height: 35px;
  text-align: left;
  //border: ${({ isSecondary }) => (isSecondary ? "none" : "1.5px solid")};
  //border-color: ${({ theme, light }) => (light ? theme.light : theme.primary)};
  //color: ${({ theme, light }) => (light ? theme.light : theme.primary)};
  border: none;
  color: white;
  border-radius: 20px;
  padding: 10px 5px 10px 15px;
  //background: transparent;
  background-color: #0E3859;
  appearance: none;
  text-transform: uppercase;
  font-size: 12px;
  text-decoration: none;
  display: inline-block;
  font-weight: ${({ theme }) => theme.bold};
  cursor: pointer;

  &:hover {
    /*background-color: ${({ light }) =>
      light ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 94, 161, 0.1)"};*/
      background-color: #D60E41;
  }

  &:disabled {
    background-color: ${({ theme, light }) => (light ? theme.light : theme.disabled)};
    color: ${({ theme, light }) => (light ? theme.light : theme.disabledBody)};
    cursor: pointer;
  }
`;


export const ButtonStyle = css`
  appearance: none;
  background: white;
  border: 2px solid ${({ theme }) => theme.secondary};
  border-radius: 20px;
  color: #0E3859;
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 18.97px;
  margin: 0 auto;
  min-width: 197px;
  padding: 9px 72px 9px 72px;
  min-height: 44px;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  margin-top: 8px;

  span {
    padding-right: 50px;
    background: url("icon_btn-arrow_f1.svg") right center no-repeat;
  }

  svg {
    position: relative;
    left: 16px;
    top: 3px;
  }

  @media ${devices.S} {
    width: 100%;
  }
  @media ${devices.M} {
    width: inherit;
  }

  &:hover {
    background-color: ${({ theme }) => theme.primary};
    border: 1px solid ${({ theme }) => theme.primary};
    color: white;
    span {
      background: url("icon_btn-arrow_f2.svg") right center no-repeat;
    }
  }

  &:disabled {
    border: 2px solid ${({ theme, light }) => (light ? theme.light : theme.disabled)};
    background-color: ${({ theme, light }) => (light ? theme.light : theme.disabled)};
    color: ${({ theme, light }) => (light ? theme.light : theme.disabledBody)};
    cursor: none;
    opacity: 0.5;

    span {
      background: url("icon_btn-arrow_f1.svg") right center no-repeat;
    }
  }
`;

export const ButtonPrimary = styled.button`
  ${ButtonStyle}
`;

export const ButtonSecondary = styled.button`
  ${ButtonStyle}
  background-color: ${({ theme }) => theme.secondary};
  color: white;
`;

export const BackgroundWrapper = styled.div`
  position: relative;
  min-height: 600px;
`;

export const ContentContainer = styled.div`
  background-color: white;
  position: relative;
  z-index: 0;
  border-radius: 14px;

  @media ${devices.S} {
    min-height: 0
  }
  @media ${devices.M} {
    min-height: 0
  }
  @media ${devices.L} {
    min-height: 750px;
  }
`;

export const BackgroundContent = styled.div`
  position: absolute;
  height: 100vh;
  
  right: 0;
  left: 0;
 
  z-index: -1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  /* background: #455c8a; */
  overflow: hidden;
  justify-content: center;
  /*box-shadow: 0 2px 6px 2px rgba(60, 64, 67, 0.15),
    0 1px 2px 0 rgba(60, 64, 67, 0.3);*/

  @media ${devices.S} {
    height: 835px;
    box-shadow: none;
  }

  /*video {
    position: absolute;
    right: 0;
    top: 0;
  }*/
  @media ${devices.M} {
   
    right: 0;
    height: 750px;

    @media (min-width: 608px) and (max-width: 1023px) {
      //height: 821px;
    }
    img {
      height: 90%;
      right: 10px;
      position: absolute;
    }
    
    video {
      //height: 371px;
    }
  }

  @media ${devices.L} {
    background: transparent; //Videobg
    justify-content: flex-end;
    img {
      height: 90%;
      right: 60px;
    }
    /*video {
      height: 750px;
      width:1978px 
    }*/
  }

  @media (min-width: 1200px) {
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
  }

  @media (min-width: 1700px) {
    justify-content: center;
  }

  /*Video Placements*/
  @media (max-width: 647px) {
    //mobile
    //border: 5px solid red;
    video {
      height: 255px;
      position: absolute;
      top: 0;
    }
  }

  @media ${devices.S} {
    video {
      right: -10px;
    }
  }


  @media (min-width: 648px) and  (max-width: 931px) {
    //mobile
    //border: 5px solid red;
    video {
      height: 371px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }


  @media (min-width: 932px) and (max-width: 1025px) {
    //tablet turquise
    //border: 5px solid #30D5C8;
    video {
      position: absolute; 
      right: 0px;
      //top: 0;
      //height: 390px;
      top: -122px;
      height: 593px;
    }
  }

  @media (min-width: 1026px) {
    //tablet turquise
    //border: 5px solid #30D5C8;
    video {
      position: absolute;
      top: 0;
      height: 750px;
      right: 0px;
    }
  }


  @media (min-width: 1225px) and (max-width: 1440px) {
    video {
      right: -300px !important
    }
  }
`;


export const BackgroundContentOld = styled.div`
  position: absolute;
  height: 100vh;
  top:-15px;
  bottom:-15px;
  right: 0;
  left: 0;
  height: calc(100% + 15px);
  z-index: -1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  /* background: #455c8a; */
  overflow: hidden;
  justify-content: center;
  /*box-shadow: 0 2px 6px 2px rgba(60, 64, 67, 0.15),
    0 1px 2px 0 rgba(60, 64, 67, 0.3);*/

  @media ${devices.S} {
    //height: 835px;
    box-shadow: none;
  }

  video {
    height: 100%;
  }

  @media ${devices.S} {
    video {
      position: absolute;
      transform: scale(1) translate(-327px, -33%);

      @media (min-width: 331px) and (max-width: 648px) {
        transform: scale(1.1) translate(-327px, -29%);
      }
    }
  }

  @media ${devices.M} {
    top: -15px;
    bottom: -15px;
    left: -20px;
    right: -20px;

    @media (min-width: 608px) and (max-width: 1023px) {
      //height: 821px;
    }

    video {
      position: absolute;
      right: -330px;
      height: 150%;
    }

    img {
      height: 90%;
      right: 10px;
      position: absolute;
    }
  }

  @media ${devices.L} {
    justify-content: flex-end;

    video {
      right: -320px;
      position: absolute;
      height: 150%;
      /* max-width: 1200px; */
    }
    img {
      height: 90%;
      right: 60px;
    }

    //background: #485b89;
  }

  @media (min-width: 1200px) {
    video {
      right: -200px;
      position: absolute;
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    video {
      bottom: 0px;
    }
    /* IE10+ CSS styles go here */
  }

  @media (min-width: 1700px) {
    justify-content: center;

    video {
      margin: 0 auto;
      left: 0;
      right: 0;
    }
  }
`;
